import $ from 'jquery'

onDomLoad(function ($dom) {
  $dom.find('table.diff tbody.unchanged').each(function () {
    const $block = $(this)
    const $lines = $block.find('tr')
    const blockSize = $lines.length
    const firstBlock = $block.is(':first-of-type')
    const finalBlock = $block.is(':last-of-type')

    const contextSize = 3 // number of unchanged lines to be shown around modified chunks
    const minFoldSize = 5 // min number of lines to fold

    const foldFilter = (i) =>
      (firstBlock || i >= contextSize) &&
      (finalBlock || i + contextSize < blockSize)
    const $linesToFold = $lines.filter(foldFilter)

    if ($linesToFold.length < minFoldSize) return

    const label = '↕ expand ' + $linesToFold.length + ' unchanged lines'
    const $expander = $(
      '<tr class="expand"><td colspan="3"><a href="#">' +
        label +
        '</a></td></tr>'
    )

    $linesToFold.wrapAll('<tbody/>').parent().replaceWith($expander)

    $expander.on('click', 'a', (e) => {
      e.preventDefault()
      $expander.replaceWith($linesToFold)
    })
  })
})
